import {combineReducers} from "redux";
import analyze from "./analyze";
import manage from "./manage";
import filter from "./filter";


const numberReducer = combineReducers({
    analyze,
    manage,
    filter
});
export default numberReducer;
